<!-- somewhere in your root component template -->
<vn-toasts aria-live="polite" aria-atomic="true"></vn-toasts>
<router-outlet></router-outlet>
